import { sortBy } from 'lib/array/arrayUtils'
import { isLpcHotelOffer } from './offerTypes'

export default function getTacticalPricePackage(offer: App.HotelOffer | App.HotelOfferSummary): App.HotelPackage | undefined {
  if (!isLpcHotelOffer(offer) || !offer.hasTactical) return
  if (offer.tacticalPricePackage) return offer.tacticalPricePackage

  const packages = offer.packages.filter(pkg => pkg.duration === offer.lowestPricePackage?.duration)
  const packagedViews = packages.filter(pkg => pkg.roomRate?.isPackaged)
  for (const view of packagedViews) {
    if (view.price > 0) {
      const index = packages.findIndex(pkg => pkg.roomType?.id === view.roomType?.id && pkg.roomRate?.packagedRatePlanId === view.roomRate?.ratePlanId)
      if (index >= 0) {
        packages[index] = view
      } else {
        packages.push(view)
      }
    }
  }
  return sortBy(packages.filter(pkg => pkg.hasTactical && pkg.price > 0), pkg => pkg.price, 'asc')[0]
}
